import * as React from 'react';
import Button from '../../../../../common/components/Button';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import {GLOBAL, LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import {useState} from 'react';
import {Catalog} from '../../../../../common/types/common';
import * as ValidateConstant from '../../../../../wizard/constants/ValidateConstant';

const LoseApplicationMotiveModalView: React.FC<any> = (props) => {
    const { loseApplicationReasons, onClose } = props;
    const [reason, setReason] = useState<Catalog>(null);
    const [error, setError] = useState<string>(ValidateConstant.ERROR_REQUIRED);
    const [showError, setShowError] = useState<boolean>(false);
    const onChangeReason = (reason: Catalog) => {
        setReason(reason);
        setError(null);
        setShowError(false);
    }
    const onPressLose = () => {
        if (error) {
            setShowError(true);
            return;
        }
        props.onPressLose(reason);
    }
    return <React.Fragment>
        <div className="text-lato text-secondary-lighten-3 text-left mb-4">

        </div>
        <div className="modal-loan-validation">
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <SelectSearchComponent
                        id="loseApplicationReason"
                        label={LOAN_APPLICATION_MX.LOSE_APPLICATION_MOTIVE}
                        placeholder={GLOBAL.SELECT}
                        value={reason}
                        data={loseApplicationReasons}
                        required={true}
                        insertInput={true}
                        onChange={onChangeReason}
                        labelError={error}
                        hasError={showError}/>
                </div>
            </div>

            <div className={`row m-0 py-3 mb-4 alert-success rounded border border-success`}>
                <div className="pl-2 mt-1 input-text-enabled">
                    <label className="status-text">Proporcionar una razón de pérdida puede ayudarte a entender mejor las
                        tendencias o circunstancias cuando necesitas mirar atrás en tu historial de negocios.</label>
                </div>
            </div>
        </div>
        <div className="pt-3 px-0 text-right text-right pr-1 border-top">
            <a className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0 mr-5"
               onClick={() => onClose()}>Cerrar</a>
            <Button type="squared"
                    customClass="btn-red loan-big-button-width"
                    text="Perdida"
                    onPress={onPressLose}/>
        </div>
    </React.Fragment>
        ;
};

export default LoseApplicationMotiveModalView;
